const RmDollarSign = (target) => target.replace(/\$/g, '');

export {
  RmDollarSign, // eslint-disable-line
};
